// extracted by mini-css-extract-plugin
export var carouselimagecontainer = "IntroTripleCarousel-module--carouselimagecontainer--b09eb";
export var defaultimage = "IntroTripleCarousel-module--defaultimage--86b16";
export var dogbiointrocontainer = "IntroTripleCarousel-module--dogbiointrocontainer--d272d";
export var expand = "IntroTripleCarousel-module--expand--2e87b";
export var mainimagecontainer = "IntroTripleCarousel-module--mainimagecontainer--d3d1c";
export var mediawrapper = "IntroTripleCarousel-module--mediawrapper--8182c";
export var onlyimagecontainer = "IntroTripleCarousel-module--onlyimagecontainer--234a4";
export var paginationcontainer = "IntroTripleCarousel-module--paginationcontainer--2b640";
export var previewimage1container = "IntroTripleCarousel-module--previewimage1container--f7c5a";
export var previewimage2container = "IntroTripleCarousel-module--previewimage2container--acdb8";
export var singleimagecontainer = "IntroTripleCarousel-module--singleimagecontainer--84b36";
export var video = "IntroTripleCarousel-module--video--ee22f";